import React from "react";
import plus from "../assets/ComCleanPlus.png";
import marketing from "../assets/marketing-kit.png";
import telemarekting from "../assets/telemarekting.png";
import posty from "../assets/posty.png";
import brochure from "../assets/brochure.png";
import image99 from "../assets/$99 value big.png";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../AppContext";
import StripeFinalCodeCheck from "./StripeFinalCodeCheck";
import image49 from "../assets/$49 Com Cleaning.png";
import TwoStepCheckout from "./TwoStepCheckout";

const CONTENT = {
  en: {
    getStarted: "Get Started:",
    pickPlan: "Pick your plan,",
    weDoRest: "we do the rest!",
    li1: "Download and segment inside the cleaning leads based on your marketing goals.",
    li2: "Launch your outreach through email, ads, calls, or",
    li3: "direct mail.",
    li4: "Track your results and fine-tune for even better",
    li5: "outcomes.",
    noAgency: "You don't need an agency. You don't need a big marketing team. Just the right list and a smart plan. It's that simple: You get the list. You do the outreach. And you keep 100% of the profits.",
    onlyPrice: "Only",
    forLeads: "leads.",
    instantDownload: "Commercial Cleaning Leads For You",
    instantDownloadBtn: "Commercial Cleaning Leads For You",
    getListNow: "Get Your List Now",
    sendMe: "Send me",
    aroundZip: "commercial cleaning business around my zipcode",
    leads: "Leads",
    buyNow: "Check Availability",
    extrasHeading: "Get These",
    extrasSpan: "Extras",
    extrasSuffix: "With Qualified Order",
    marketingKit: "The Commercial Cleaning Marketing Made Easy Marketing Kit!",
    voiceMail: "Bonus Voice Mail Script",
    postcard: "Bonus Postcard Templates",
    brochure: "Bonus Brouchure Templates",
  },
  es: {
    getStarted: "Comienza:",
    pickPlan: "Elige tu plan,",
    weDoRest: "¡nosotros hacemos el resto!",
    li1: "Descarga y segmenta los leads de limpieza según tus objetivos de marketing.",
    li2: "Lanza tu outreach por correo, anuncios, llamadas o",
    li3: "correo directo.",
    li4: "Mide tus resultados y afina para obtener",
    li5: "mejores resultados.",
    noAgency: "No necesitas una agencia ni un equipo de marketing grande. Solo la lista correcta y un plan inteligente. Es así de simple: Tú obtienes la lista. Tú haces el contacto. Y te quedas con el 100% de las ganancias.",
    onlyPrice: "Solo",
    forLeads: "leads.",
    instantDownload: "Leads de Limpieza Comercial Para Ti",
    instantDownloadBtn: "Leads de Limpieza Comercial Para Ti",
    getListNow: "Consigue tu lista ahora",
    sendMe: "Envíame",
    aroundZip: "negocios de limpieza comercial cerca de mi código postal",
    leads: "Leads",
    buyNow: "Ver disponibilidad",
    extrasHeading: "Consigue estos",
    extrasSpan: "extras",
    extrasSuffix: "con pedido calificado",
    marketingKit: "¡Kit de marketing de limpieza comercial hecho fácil!",
    voiceMail: "Guion de buzón de voz de regalo",
    postcard: "Plantillas de postales de regalo",
    brochure: "Plantillas de folleto de regalo",
  },
};

const SecondForm = ({ lang = "en" }) => {
  const navigate = useNavigate();
  const t = CONTENT[lang] || CONTENT.en;

  const { zipcodes, setZipcodes, buyNow, setBuyNow, loadingHeader, leadsCount, setLeadsCount, selectedPrice, setSelectedPrice } = useAppContext();

  const plans = [
    { qty: 50, price: 39 },
    { qty: 200, price: 99 },
    { qty: 500, price: 199 },
  ];

  return (
    // <section className="py-16 bg-gradient-to-br from-cyan-200 via-blue-200 to-cyan-300">
    <section className="py-16 bg-[#DBE4E5]">
      <div className="relative z-10 container mx-auto px-4 py-8">
        {/* <div className="flex flex-col lg:flex-row justify-center gap-8"> */}
        <div className="block lg:flex max-w-5xl mx-auto">

          {/* Left Content */}
          <div className="flex-1  max-w-xl text-center lg:text-left">
            <div className="mb-3 max-w-lg">
              <h2 className="text-[#26A94A] font-bold text-3xl ">
                {" "}
                {t.getStarted}{" "}
                <span className="text-[#1465B7]">
                  {t.pickPlan} <br /> {t.weDoRest}
                </span>
              </h2>
              {/* </div> */}
              <div>
                <ul className="list-disc ml-5 text-lg text-gray-700 text-left">
                  <li>{t.li1}</li>
                  <li className="my-2">{t.li2} <br /> {t.li3}</li>
                  <li>{t.li4} <br /> {t.li5}</li>
                </ul>
              </div>
              <div className="mt-3">
                <p className="text-gray-700 text-lg leading-normal gap-y-2">
                  {t.noAgency}
                </p>
              </div>

              <div className="font-semibold text-[#26A94A] text-lg">
                <p>
                  {t.onlyPrice} ${selectedPrice / 100} for {leadsCount} {t.forLeads}
                  <br />
                  {t.instantDownload}
                </p>
              </div>
            </div>

          </div>

          {/* Right Form – 2 Step Checkout */}
          <div className="flex-shrink-0 md:min-w-md lg:min-w-md w-full lg:w-80">
            {(buyNow === 'home' || buyNow === 'form') && (
              <TwoStepCheckout lang={lang} />
            )}

            {loadingHeader && (
              <div className="flex items-center justify-center min-h-[400px]">
                <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></div>
              </div>
            )}

            {/* Payment form lives in Header only — avoid a second StripeFinalCodeCheck (duplicate API calls) */}
            {buyNow === "download" && <StripeFinalCodeCheck lang={lang} />}
            {buyNow === "payment" && (
              <button
                type="button"
                className="w-full bg-[#FAF26B] hover:bg-yellow-300 text-[#1465B7] font-bold py-3 rounded-full border-3 border-[#26A94A] cursor-pointer"
                onClick={() => {
                  document.getElementById("checkout-form-anchor")?.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                {lang === "es" ? "Completar el pago arriba ↑" : "Complete payment above ↑"}
              </button>
            )}
          </div>

        </div>
      </div>
      <div className="container mx-auto max-w-5xl px-4 md:px-0">
        <div className="text-center mb-12">
          {/* <div className="flex mx-auto items-center gap-5 justify-between"> */}
          {/* <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 justify-center sm:justify-between mx-auto">
   
                <img src={plus} width={200} height={125} />
               <div className="mt-4">
                 <p className="text-3xl text-[#1465B7] font-bold">
                   Get These <span className="text-[#26A94A]">Extras</span> With
                   Every Order
                 </p>
               </div>
               <img src={plus} width={200} height={125} />
             </div>
    */}
          <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-5 justify-center sm:justify-between mx-auto">
            <img src={plus} width={200} height={125} />

            <div className="mt-4">
              <h2 className="text-3xl text-[#1465B7] font-bold">
                {t.extrasHeading} <span className="text-[#26A94A]">{t.extrasSpan}</span> {t.extrasSuffix}
              </h2>
            </div>

            <img src={plus} width={200} height={125} className="hidden sm:block" />
          </div>
          <div className="container mx-auto max-w-5xl px-4 md:px-0 mt-8">
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9 max-w-4xl justify-center mx-auto">
              {/* <div>
                 <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                   <img src={marketing} width={130}/>
                 </div>
                 <p className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                   The Commercial <br/> Cleaning Marketing <br/>Made Easy <br/> Marketing Kit !
                 </p>
               </div> */}
              <div>
                <div className="relative flex justify-center items-center">
                  {/* First Image */}
                  <div className="w-40 h-40 rounded-full flex items-center justify-center  z-20">
                    <img src={image99} width={130} />
                  </div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10">
                    <img src={marketing} width={130} />
                  </div>

                  {/* Second Image - overlapping the first */}
                </div>

                <h3 className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center mt-4 ml-4">
                  {t.marketingKit}
                </h3>
              </div>

              <div>
                <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                  <img src={telemarekting} width={130} />
                </div>
                <h3 className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                  {t.voiceMail}
                </h3>
              </div>
              <div>
                <div className="w-40 h-40 rounded-full flex items-center justify-center mx-auto">
                  <img src={posty} width={130} />
                </div>
                <h3 className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center">
                  {t.postcard}
                </h3>
              </div>
              <div>
                <div className="relative flex justify-center items-center">
                  <div className="w-40 h-40 rounded-full flex items-center justify-center  z-20">
                    <img src={image49} width={130} />
                  </div>
                  <div className="w-40 h-40 rounded-full flex items-center justify-center -ml-12 z-10">
                    <img src={brochure} width={130} />
                  </div>
                </div>
                <h3 className="text-[#1465B7] font-semibold text-lg leading-relaxed text-center ml-6">
                  {t.brochure}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SecondForm;
